import React, { useMemo } from 'react';
import { useFormikContext } from 'formik';
import BaseSelect, { Option } from './BaseSelect';

type FormikSelectProps<T = any> = {
  name: string;
  options: Option<T>[];
  isMulti?: boolean;
  isClearable?: boolean;
  placeholder?: string;
  isDisabled?: boolean;
  
  clearValue?: any;
};

const FormikSelect = <T,>({ name, options, isMulti = false, isClearable = false, placeholder, isDisabled, clearValue }: FormikSelectProps<T>) => {
  const formik = useFormikContext<any>();
  const valueInForm = formik?.values?.[name];

  const currentValue = useMemo(() => {
    if (isMulti) {
      if (!Array.isArray(valueInForm)) return [];
      return options.filter((o) => (valueInForm || []).some((v: any) => String(v) === String(o.value)));
    }
    if (valueInForm === null || valueInForm === undefined || valueInForm === '') return null;
    return options.find((o) => String(o.value) === String(valueInForm)) ?? null;
  }, [valueInForm, options, isMulti]);

  const handleChange = (selected: any) => {
    if (isMulti) {
      const arr = (selected || []).map((s: Option<T>) => s.value);
      formik.setFieldValue(name, arr);
    } else {
      if (!selected) {
        formik.setFieldValue(name, clearValue !== undefined ? clearValue : '');
      } else {
        formik.setFieldValue(name, (selected as Option<T>).value);
      }
    }
  };

  return (
    <BaseSelect
      options={options}
      value={currentValue}
      onChange={handleChange}
      isMulti={isMulti}
      isClearable={isClearable}
      placeholder={placeholder}
      isDisabled={isDisabled}
    />
  );
};

export default FormikSelect;